import { IonAccordion } from '@ionic/react';
import React, { ComponentProps } from 'react';
import { Controller } from 'react-hook-form';
import { IonicButton } from 'ionic-ui';
import SetupItem from '../../../../../../components/Dashboard/getting-started/accordion/SetupItem';
import AccordionHeader from '../../../../../../components/Dashboard/getting-started/accordion/AccordionHeader';
import PhoneNumberInput from '../../../../../../components/ui/PhoneNumberInput';
import { useUserContactInformationService } from '../../../../../../services/userProfile/hooks/useUserContactInformationService';

type Props = ComponentProps<typeof IonAccordion>;
export default function UserContactInfoAccordion(props: Props) {
  const { control, onSubmit, isDirty } = useUserContactInformationService();

  return (
    <IonAccordion value="contact-Info" {...props}>
      <AccordionHeader>Contact Information</AccordionHeader>
      <form
        onSubmit={onSubmit}
        slot="content"
        className="flex flex-col p-4 gap-4 bg-background dark:bg-background-accent"
      >
        <Controller
          name="primary_information.middle_name"
          control={control}
          render={({ field, fieldState }) => (
            <SetupItem
              {...field}
              label="middle name"
              fieldType="text"
              hint={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="secondary_information.user_name"
          control={control}
          render={({ field, fieldState }) => (
            <SetupItem
              {...field}
              label="User name"
              fieldType="text"
              hint={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="primary_information.date_of_birth"
          control={control}
          render={({ field, fieldState }) => (
            <SetupItem
              {...field}
              label="Date of Birth"
              fieldType="date"
              value={field.value?.trim()}
              hint={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="primary_information.secondary_email"
          control={control}
          render={({ field, fieldState }) => (
            <SetupItem
              {...field}
              label="secondary email"
              fieldType="email"
              hint={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="primary_information.secondary_phone"
          control={control}
          render={({ field, fieldState }) => (
            <PhoneNumberInput
              {...field}
              variant="filled"
              label="secondary Phone number"
              hint={fieldState.error?.message}
              size="lg"
              placeholder="e.g. 0801 234 5678"
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
        <Controller
          name="secondary_information.website"
          control={control}
          render={({ field, fieldState }) => (
            <SetupItem
              {...field}
              label="website"
              fieldType="text"
              hint={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="secondary_information.short_bio"
          control={control}
          render={({ field, fieldState }) => (
            <SetupItem
              {...field}
              label="Short Bio"
              fieldType="textarea"
              className="resize-none"
              hint={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="primary_information.additional_info"
          control={control}
          render={({ field, fieldState }) => (
            <SetupItem
              {...field}
              label="addition note"
              fieldType="textarea"
              className="resize-none"
              hint={fieldState.error?.message}
            />
          )}
        />
        {/* ✅ Submit Button */}
        <div className="py-4">
          <IonicButton
            type="submit"
            className="w-full rounded-sm"
            disabled={!isDirty}
          >
            Save
          </IonicButton>
        </div>
      </form>
    </IonAccordion>
  );
}
